import React from "react";

/* eslint-disable max-len */
export default function SlideNextButtonFocus() {
    return (
        <svg version="1.1" id="레이어_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px"
			y="0px" viewBox="0 0 17.1 20.7" enableBackground="new 0 0 17.1 20.7" xmlSpace="preserve">
		<g>
			<path opacity="0.6" fill="#64696D" stroke="#232323" strokeWidth="0.9798" strokeMiterlimit="10" d="M14.4,20.1H2.6
				c-1.1,0-2-0.9-2-2V2.6c0-1.1,0.9-2,2-2h11.8c1.1,0,2,0.9,2,2v15.5C16.4,19.2,15.5,20.1,14.4,20.1z"/>
			<g>
				<line fill="none" stroke="#FFFFFF" strokeLinecap="round" strokeMiterlimit="10" x1="5.9" y1="4.9" x2="11.5" y2="10.3"/>
				<line fill="none" stroke="#FFFFFF" strokeLinecap="round" strokeMiterlimit="10" x1="11.5" y1="10.3" x2="5.9" y2="15.8"/>
			</g>
		</g>
		</svg>
    );
}
